module.exports = __webpack_public_path__ + "client/styles/fonts/SourceSansPro-Regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./client/styles/fonts/SourceSansPro-Regular.ttf
// module id = 1483
// module chunks = 0